<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  background: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.page {
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
}

.header {
  display: flex;
  align-items: center;
  height: 48px;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 6px;
  padding: 0 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.header-side {
  width: 56px;
  flex-shrink: 0;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.back {
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
}

.logout {
  cursor: pointer;
  color: #909399;
  font-size: 14px;
}
</style>